







































import {Emit, Prop} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Pile, Fournisseur} from '@/models';

import CrudPileEdit from '@/components/Crud/Pile/Edit.vue';

@Component({
	components: {
		CrudPileEdit,
	}
})
export default class CrudPileEditDialog extends Vue {
	@InOut({ type: Pile  , isVModel: true }) private value!: Pile;
	@Prop({ type: Fournisseur, default: null}) fournisseur: Fournisseur;

	@Emit()
	private onSubmit(pile: Pile) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
